import { IAuthModel } from '../identitymanagement/IAuthModel';

export class AppUser {
  userName = '';
  password = '';
  isTwoFactorEnabled = false;
  authModel: IAuthModel;
  isPasswordReset = true;
}
